import {
  ShieldCheck, Flame, GraduationCap, Users, TrendingUp, Wrench, Factory,
  Headset, HardHat, Building2, Truck, Briefcase, Cog, ClipboardList, Search,
  FlameKindling, DoorOpen, UserCheck, Siren, LayoutGrid, FireExtinguisher,
  Wind, Phone, Mail, MessageCircle, MapPin, ArrowRight, ArrowUpRight, Check,
  CheckCircle2, Menu, X, ChevronDown, Quote, Star, Clock, Calendar, Send,
} from "lucide-react";

const MAP = {
  ShieldCheck, Flame, GraduationCap, Users, TrendingUp, Wrench, Factory,
  Headset, HardHat, Building2, Truck, Briefcase, Cog, ClipboardList, Search,
  FlameKindling, DoorOpen, UserCheck, Siren, LayoutGrid, FireExtinguisher,
  Wind, Phone, Mail, MessageCircle, MapPin, ArrowRight, ArrowUpRight, Check,
  CheckCircle2, Menu, X, ChevronDown, Quote, Star, Clock, Calendar, Send,
};

// String -> lucide icon renderer used across data-driven sections.
export default function Icon({ name, className, ...props }) {
  const Cmp = MAP[name] || ShieldCheck;
  return <Cmp className={className} {...props} />;
}
